/* Kuk çerez barı ve tercih paneli (sop/footer-hesap.json 9-11; eşleme kurulum-olcum-operasyon 11).
   Shopify Customer Privacy API: shouldShowBanner() true ise bar görünür; karar setTrackingConsent ile yazılır
   (YALNIZ GEREKLİ: hepsi kapalı; KABUL ET: analitik, pazarlama, tercih açık; panel: Analitik → analytics ve
   preferences, Pazarlama → marketing; sale_of_data her zaman kapalı). API yüklenemezse bar yine görünür, tercih
   localStorage'a yazılır, pikseller kapalı kalır. Bar görünürken ürün sayfasının yapışkan barı üstüne oturur
   (--kuk-bar-alt). Deneme için ?kuk_cerez adres parametresi barı her durumda gösterir. Olay: 'kuk:olay' cerez_tercihi. */
(() => {
  if (window.kukCerez) return;
  window.kukCerez = true;
  const ANAHTAR = 'kuk-cerez-tercihi';
  let api = null;

  const yerelOku = () => { try { return JSON.parse(window.localStorage.getItem(ANAHTAR) || 'null'); } catch (h) { return null; } };
  const yerelYaz = (t) => { try { window.localStorage.setItem(ANAHTAR, JSON.stringify(t)); } catch (h) { /* gizli pencere */ } };
  const bar = () => document.querySelector('[data-kuk-cerez]');
  const panel = () => document.querySelector('[data-cerez-panel]');
  const azHareket = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const barAc = () => {
    const b = bar();
    if (!b) return;
    b.hidden = false;
    document.documentElement.style.setProperty('--kuk-bar-alt', `${b.offsetHeight}px`);
  };
  const barKapat = () => {
    const b = bar();
    if (!b || b.hidden) return;
    b.classList.add('is-iniyor');
    document.documentElement.style.setProperty('--kuk-bar-alt', '0px');
    setTimeout(() => { b.hidden = true; b.classList.remove('is-iniyor'); }, azHareket() ? 0 : 200);
  };

  const yaz = (tercih, secim) => {
    const izin = { analytics: tercih.analitik, marketing: tercih.pazarlama, preferences: tercih.analitik, sale_of_data: false };
    yerelYaz({ analitik: tercih.analitik, pazarlama: tercih.pazarlama, zaman: new Date().toISOString() });
    // Olay onay işlendikten sonra: 'Kabul' seçiminde özel piksel ancak onaydan sonra yüklenir
    const bildir = () => window.kukOrtak?.olay('cerez_tercihi', { secim, analitik: tercih.analitik, pazarlama: tercih.pazarlama });
    if (api) { try { api.setTrackingConsent(izin, bildir); } catch (h) { bildir(); } } else bildir();
    barKapat();
  };

  const mevcut = () => {
    if (api) {
      try {
        const c = api.currentVisitorConsent();
        if (c && (c.analytics !== '' || c.marketing !== '')) return { analitik: c.analytics === 'yes', pazarlama: c.marketing === 'yes' };
      } catch (h) { /* yerel kayda düşer */ }
    }
    const y = yerelOku();
    return y ? { analitik: !!y.analitik, pazarlama: !!y.pazarlama } : { analitik: false, pazarlama: false };
  };

  const panelAc = () => {
    const p = panel();
    if (!p) return;
    const t = mevcut();
    p.querySelector('[data-cerez-analitik]').checked = t.analitik;
    p.querySelector('[data-cerez-pazarlama]').checked = t.pazarlama;
    window.kukOrtak?.altSayfa.ac(p);
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cerez-ayarlari]')) { e.preventDefault(); panelAc(); return; }
    const secim = e.target.closest('[data-cerez-secim]');
    if (secim) {
      const kabul = secim.dataset.cerezSecim === 'kabul';
      yaz({ analitik: kabul, pazarlama: kabul }, kabul ? 'kabul' : 'yalniz_gerekli');
      return;
    }
    if (e.target.closest('[data-cerez-kaydet]')) {
      const p = panel();
      yaz({ analitik: p.querySelector('[data-cerez-analitik]').checked, pazarlama: p.querySelector('[data-cerez-pazarlama]').checked }, 'ayarlar');
      p.close();
    }
  });

  const baslat = () => {
    const zorla = new URLSearchParams(window.location.search).has('kuk_cerez');
    const yerelKarar = !!yerelOku();
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { if (zorla || !yerelKarar) barAc(); return; }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (hata) => {
      if (hata) { if (zorla || !yerelKarar) barAc(); return; }
      api = window.Shopify.customerPrivacy;
      let goster = false;
      try { goster = api.shouldShowBanner(); } catch (h) { goster = !yerelKarar; }
      if (zorla || goster) barAc();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();
